module.exports = (__webpack_require__(0))(9);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/auth.js from dll-reference girder_lib
// module id = 79
// module chunks = 0